// @flow
import * as React from 'react';
import 'app/common/react/components/profile/showcase/ShopShowcaseSection/ShopShowcaseSection.scss';
import cx from 'classnames';
import hoverable from 'app/common/lib/react/hoverable';
import PropTypes from 'prop-types';
import type { ShowcaseShopType } from 'app/common/react/components/profile/showcase/commonTypes';
import { Mask } from 'gestalt';

const SHOWCASE_HEIGHT = 377;
const SHOWCASE_WIDTH = 768;
const SIDE_IMAGE_WIDTH = 226;
const SHOP_CIRCLE_DIM = 80;

type ShopHoverCollageType = {
  classname: string,
  imgUrlBottom: string,
  imgUrlTop: string,
  isHovering: boolean,
};

export const ShowcaseShopProps = PropTypes.shape({
  pins: PropTypes.shape({
    image_large_url: PropTypes.string,
  }),
  hoverHandlers: PropTypes.objectOf(PropTypes.func).isRequired,
  isHovering: PropTypes.bool.isRequired,
  layout_params: PropTypes.shape({
    action_text: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  link_data: PropTypes.shape({
    id: PropTypes.string,
  }),
  type: PropTypes.string,
});

export function ShopHoverCollage(props: ShopHoverCollageType) {
  const { classname, imgUrlBottom, imgUrlTop } = props;
  const topImageStyle = {
    backgroundImage: `url(${imgUrlTop})`,
    top: 0,
  };

  const bottomImageStyle = {
    backgroundImage: `url(${imgUrlBottom})`,
    top: 189,
  };

  return (
    <div>
      <div
        className={cx('shopHoverImage', classname, { hover: props.isHovering })}
        style={topImageStyle}
      />
      <div
        className={cx('shopHoverImage', classname, { hover: props.isHovering })}
        style={bottomImageStyle}
      />
    </div>
  );
}

export function ShopShowcaseSection(props: ShowcaseShopType) {
  const { isHovering, layout_params, pins } = props;

  if (pins.length === 0) {
    return null;
  }

  const imgUrl = pins[0].image_large_url;
  const showHoverState = pins.length >= 5 && isHovering;
  const coverStyle = {
    backgroundImage: `url(${imgUrl})`,
    height: SHOWCASE_HEIGHT,
    width: showHoverState ? SHOWCASE_WIDTH - SIDE_IMAGE_WIDTH * 2 : SHOWCASE_WIDTH,
  };

  return (
    <div className="ShopShowcaseSection" {...props.hoverHandlers}>
      <Mask height={SHOWCASE_HEIGHT} shape="rounded" width={SHOWCASE_WIDTH}>
        <div className="imageWash absolute flex items-center justify-center">
          {pins.length >= 5 ? (
            <ShopHoverCollage
              classname={'leftCollage'}
              imgUrlBottom={pins[2].image_large_url}
              imgUrlTop={pins[1].image_large_url}
              isHovering={isHovering}
            />
          ) : null}
          <div className="shopCircle">
            <Mask height={SHOP_CIRCLE_DIM} shape="circle" width={SHOP_CIRCLE_DIM}>
              <div className="flex items-center justify-center shopCircleText white bg-blue">
                <p>{layout_params.action_text}</p>
              </div>
            </Mask>
          </div>
          {pins.length >= 5 ? (
            <ShopHoverCollage
              classname={'righCollage'}
              imgUrlBottom={pins[4].image_large_url}
              imgUrlTop={pins[3].image_large_url}
              isHovering={isHovering}
            />
          ) : null}
          <div className="shopCardImage" style={coverStyle} />
        </div>
      </Mask>
    </div>
  );
}

export default hoverable(ShopShowcaseSection);
